import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import About from "./pages/app/about/About";
import Contacts from "./pages/app/contacts/Contacts";
import Services from "./pages/app/courses/Courses";
// import Publications from "./pages/app/publications/Publications";
import SdgsProjects from "./pages/app/sdgsProjects/SdgsProjects";
import Initiatives from "./pages/app/initiatives/Initiatives";
import Conferences from "./pages/app/conferences/Conferences";
import Activities from "./pages/app/activities/Activities";
import Donates from "./pages/app/donates/Donates";
import Login from "./pages/auth/Login";
import Navbar from "./components/navbar/Navbar";
import Error from "./components/errors-messages/Error";
import Message from "./components/errors-messages/Message";
import { login } from "./apis/authApi";
import React from "react";
import { useState, useEffect } from "react";
import "./App.css";

function App() {
  const [state, setState] = useState({
    isAuth: false,
    token: null,
    adminId: null,
    authLoading: false,
    error: null,
    message: null,
  });
  useEffect(() => {
    const token = localStorage.getItem("token");
    const expiryDate = localStorage.getItem("expiryDate");
    if (!token || !expiryDate) {
      return;
    }
    if (new Date(expiryDate) <= new Date()) {
      logoutHandler();
      return;
    }
    const adminId = localStorage.getItem("adminId");
    const remainingMilliseconds =
      new Date(expiryDate).getTime() - new Date().getTime();
    setState((prevState) => {
      return { ...prevState, isAuth: true, token: token, adminId: adminId };
    });
    setAutoLogout(remainingMilliseconds);
  }, []);

  // mobileNavHandler = (isOpen) => {
  //   setState({ showMobileNav: isOpen, showBackdrop: isOpen });
  // };

  // errorClickHandler = () => {
  //   setState((prevState) => {
  //     return { ...prevState, error: null };
  //   });
  // };

  const logoutHandler = () => {
    setState((prevState) => {
      return {
        ...prevState,
        isAuth: false,
        token: null,
        adminId: null,
        message: { message: "you've been logged out" },
        error: null,
      };
    });
    localStorage.removeItem("token");
    localStorage.removeItem("expiryDate");
    localStorage.removeItem("adminId");
  };

  const loginHandler = async (event, authData) => {
    event.preventDefault();

    setState((prevState) => {
      return { ...prevState, authLoading: true };
    });
    const { data, error } = await login(authData);

    if (!data && error) {
      console.log(error);
      return setState((prevState) => {
        return {
          ...prevState,
          isAuth: false,
          token: null,
          adminId: null,
          error: error,
          authLoading: false,
        };
      });
    }

    // fetch("https://shark-app-2ttko.ondigitalocean.app/auth/login", {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    //   body: JSON.stringify({
    //     email: authData.email,
    //     password: authData.password,
    //   }),
    // })

    setState((prevState) => {
      return {
        ...prevState,
        isAuth: true,
        token: data.token,
        authLoading: false,
        adminId: data.adminId,
      };
    });
    localStorage.setItem("token", data.token);
    localStorage.setItem("adminId", data.adminId);
    const remainingMilliseconds = 3 * 24 * 60 * 60 * 1000;
    const expiryDate = new Date(new Date().getTime() + remainingMilliseconds);
    localStorage.setItem("expiryDate", expiryDate.toISOString());
    setAutoLogout(remainingMilliseconds);
    return { message: "succses" };
  };

  const setAutoLogout = (milliseconds) => {
    setTimeout(() => {
      logoutHandler();
    }, milliseconds);
  };

  const errorHandler = () => {
    setState((prevState) => {
      return { ...prevState, error: null, message: null };
    });
  };
  return (
    <>
      <Router>
        <Navbar isAuth={state.isAuth} onLogout={logoutHandler} />
        <Error error={state.error} onHandle={errorHandler} />
        <Message message={state.message} onHandle={errorHandler} />
        <Routes>
          <Route
            path="/"
            element={<About token={state.token} isAuth={state.isAuth}></About>}
          ></Route>
          <Route
            path="contact-us"
            element={
              <Contacts token={state.token} isAuth={state.isAuth}></Contacts>
            }
          ></Route>
          <Route
            path="donates"
            element={
              <Donates token={state.token} isAuth={state.isAuth}></Donates>
            }
          ></Route>
          <Route
            path="courses"
            element={
              <Services token={state.token} isAuth={state.isAuth}></Services>
            }
          ></Route>
          <Route
            path="initiatives"
            element={
              <Initiatives
                token={state.token}
                isAuth={state.isAuth}
              ></Initiatives>
            }
          ></Route>
          <Route
            path="conferences"
            element={
              <Conferences
                token={state.token}
                isAuth={state.isAuth}
              ></Conferences>
            }
          ></Route>
          <Route
            path="sdgs&Projects"
            element={
              <SdgsProjects
                token={state.token}
                isAuth={state.isAuth}
              ></SdgsProjects>
            }
          ></Route>
          {/* <Route
            path="publications"
            element={
              <Publications
                token={state.token}
                isAuth={state.isAuth}
              ></Publications>
            }
          ></Route> */}
          <Route
            path="activities"
            element={
              <Activities
                token={state.token}
                isAuth={state.isAuth}
              ></Activities>
            }
          ></Route>
          <Route
            path="admin"
            element={
              <Login onLogin={loginHandler} loading={state.authLoading}></Login>
            }
          ></Route>
        </Routes>
      </Router>
    </>
  );
}

export default App;
